import { useRuntimeStore } from "@/store/runtime"
// import { useDataStore } from "@/store/data"
import { defineStore } from "pinia";


export const useApi = defineStore("apiStore", () => {


    const runtimeStore = useRuntimeStore();
    // const dataStore = useDataStore();

    const copyObject = (obj) => {
        const copy = JSON.parse(JSON.stringify(obj))

        // console.log("ios polyfill commented out")
        // if (!AbortSignal?.timeout){ // polyfill ios15.6 eg
        //     AbortSignal.timeout = function (timeout) {
        //         const controller = new AbortController()
        //         setTimeout(() => controller.abort(), timeout)
        //         return controller.signal
        //     }
        // }

        copy.signal = AbortSignal.timeout(3 * 1000)
        return copy
    }

    // console.log('runtimeStore.user', runtimeStore.session.user)

    // new tracker api

    const default_tracker_options = () => {

        return {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + runtimeStore?.session?.user?.token,
                'Picker': VERSION,
            },
            mode: "cors", // no-cors, same-origin
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url    
        }

    }


    const default_local_options = () => {

        return {
            method: 'GET',
            headers: {
                // 'Accept': 'application/json',
                // 'Content-Type': 'application/json',
                // 'Authorization': 'Token ' + runtimeStore?.session?.user?.token,
                // 'Picker': VERSION,
            },
            mode: "cors", // no-cors, same-origin
            
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url    
        }

    }


    const trackerURL = runtimeStore?.session?.settings?.tracker_server_url

    // const localWebServerURL = ENVIRONMENT === "development" ? 
    //     // "http://192.168.152.151:8080" :  "http://localhost:8080"
    //     "http://192.168.152.151:8080" :  "http://127.0.0.1:8080"

    const localWebServerURL = "http://127.0.0.1:8080"

    const tracker = {

        deleteAuthToken: async (data) => {  // secure data test post
            const options = copyObject(default_tracker_options())
            options.body = JSON.stringify(data)

            let response = await fetch(`${trackerURL}/picker/api/auth/delete_token`, options).catch(error => {
                console.error('There was a problem with the deleteAuthToken operation:', error)
            });
            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },


        getUserMultiTokens: async () => {  // secure data test post
            const options = copyObject(default_tracker_options())
            options.method = 'GET'

            let response = await fetch(`${trackerURL}/picker/api/auth/get_tokens`, options).catch(error => {
                console.error('There was a problem with the deleteAuthToken operation:', error)
            });
            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },



        login: async (data) => {  // secure data test post

            // custom options
            const options =  {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Picker': VERSION,
                },
                method: 'POST',
                mode: "cors", // no-cors, same-origin
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url    
            }
            options.body = JSON.stringify(data)

            let response = await fetch(`${trackerURL}/picker/api/auth/login`, options).catch(error => {
                console.error('There was a problem with the deleteAuthToken operation:', error)
            });
            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },


        logout: async () => {  // secure data test get
            const options = copyObject(default_tracker_options())
            options.method = 'GET'

            let response = await fetch(`${trackerURL}/picker/api/auth/logout`, options).catch(error => {
                console.error('There was a problem with the logout operation:', error)
            });

            console.log('logout response', response?.status)


            if (response) {
                return {
                    response: response,
                    data: await response.json(),
                }
            }
            else {
                return {
                    response: response,
                    data: null,
                }
            }

        },

        
        upcheck: async () => {  // secure data test get
            const options = copyObject(default_tracker_options())
            options.method = 'HEAD'
            

            try {
                await fetch(`${trackerURL}/picker/api/upcheck`, options)
                return true
            } catch (error) {
                console.error('There was a problem with the upcheck operation:', error)
                return false
            }
        },

        sdtg: async () => {  // secure data test get
            const options = copyObject(default_tracker_options())
            options.method = 'GET'

            let response = await fetch(`${trackerURL}/picker/api/secure_data_test_get`, options).catch(error => {
                console.error('There was a problem with the SDTG operation:', error)
            })

            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },

        getUserAuth: async (username) => {  // secure data test get
            const options = copyObject(default_tracker_options())
            options.method = 'GET'

            const url = `${trackerURL}/picker/api/auth/get_user_auth?username=${username}`
            
            let response = await fetch(url, options).catch(error => {
                console.error('There was a problem with the getUserAuth operation:', error)
            })

            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },



        sdtp: async (data) => {  // secure data test post
            const options = copyObject(default_tracker_options())
            options.body = JSON.stringify(data)
            let response = await fetch(`${trackerURL}/picker/api/secure_data_test_post`, options).catch(error => {
                console.error('There was a problem with the SDTP operation:', error)
            });
            if (response)
                return {
                    response: response,
                    data: await response.json(),
                }
            else
                return {
                    response: response,
                    data: null,
                }
        },



        userChangePassword: async (data) => {
            const options = copyObject(default_tracker_options())

            options.body = JSON.stringify(data)
            let response = await fetch(`${trackerURL}/picker/api/change/password`, options).catch(error => {
                console.error('There was a problem with the USERCHANGEPASSWORD operation:', error)
            })
            return {
                response: response,
                data: await response.json(),
            }

        },

        uploadFile: async (file) => {
            const options = copyObject(default_tracker_options())

            options.signal = AbortSignal.timeout(5 * 60 * 1000)
            options.body = JSON.stringify(file)

            const response = await fetch(`${trackerURL}/picker/api/upload/file`, options).catch(error => {
                console.log(`There was a problem with the UPLOADFILE operation: ${error.name}`)
                console.log(file)
                console.log(error)
            })

            return response
        },



        uploadFeature: async (feature) => {
            const options = copyObject(default_tracker_options())
            options.body = JSON.stringify(feature)

            const response = await fetch(`${trackerURL}/picker/api/upload/feature`, options).catch(error => {
                console.error('There was a problem with the UPLOADFEATURE operation:', error)
            })

            // console.log(await response.json())

            return response
        },



        uploadJournalDay: async (day) => {
            const options = copyObject(default_tracker_options())
            options.body = JSON.stringify(day)

            const response = await fetch(`${trackerURL}/picker/api/upload/journal_day`, options).catch(error => {
                console.error('There was a problem with the uploadJournalDay operation:', error)
            })

            // console.log(await response.json())

            return response
        },

        getStambecchiPreviousMonth: async () => {
            console.log("download stambecchi")
            if (!localStorage.stambecchiPreviousMonth) {
                const emptyStambecchi = {
                    "type": "FeatureCollection",
                    "properties": {
                        "style": "ibex_previous_month",
                        "created_at": "2000-01-01"
                    },
                    "features": []
                }
                localStorage.stambecchiPreviousMonth = JSON.stringify(emptyStambecchi)
            }

            const options = copyObject(default_tracker_options())
            options.method = 'GET'

            const url = `${trackerURL}/picker/api/get_stambecchi_previous_month`

            let response = await fetch(`${url}`, options).catch(error => {
                console.error('There was a problem with the get /api/file/list over local webserver operation:', error)
            });

            if (!response) return false
            
            const fakeStambecchi = {
                "type": "FeatureCollection",
                "properties": {
                    "style": "ibex_previous_month",
                    "created_at": "2025-11-30"
                },
                "features": [
                    {
                        "type": "Feature",
                        "properties": {
                            "amount": "5",
                            "user": "Nome",
                            "date": "2025-11-20",
                            "title": "ciao",
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [
                                7.202850667913623,
                                45.48590029558903
                            ]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "amount": "5",
                            "user": "Nome",
                            "date": "2025-12-2",
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [
                                7.287185534963442,
                                45.50001742773529
                            ]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "amount": "5",
                            "user": "Nome",
                            "date": "2025-12-20",
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [
                                7.364631187999322,
                                45.50982939606587
                            ]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "amount": "5",
                            "user": "Nome",
                            "date": "2025-11-10",
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [
                                7.431265369397352,
                                45.551455218179484
                            ]
                        }
                    }
                ]
            }

            // localStorage.stambecchiPreviousMonth = JSON.stringify(fakeStambecchi)
            
            const stambecchi = await response.json()
            console.log(stambecchi)
            localStorage.setItem("stambecchiPreviousMonth",  JSON.stringify(stambecchi) )

            return true
        },



        getAnnotazioni: async () => {
            
            console.log("download annotazioni")

            // const emptyAnnotazioni = {
            //     "type": "FeatureCollection",
            //     "properties": {
            //         "style": "annotazioni",
            //     },
            //     "features": []
            // }
            // if (!localStorage.annotazioni_personali) {
            //     localStorage.annotazioni_personali = JSON.stringify(emptyAnnotazioni)
            // }
            // if (!localStorage.annotazioni_colleghi) {
            //     localStorage.annotazioni_colleghi = JSON.stringify(emptyAnnotazioni)
            // }
            
            // const options = copyObject(default_tracker_options())
            // options.method = 'GET'

            // const url = `${trackerURL}/picker/api/get_annotazioni`

            // let response = await fetch(`${url}`, options).catch(error => {
            //     console.error('There was a problem with the get /api/file/list over local webserver operation:', error)
            //     return null
            // });
            
            // if (!response) return false

            // const annotazioni = await response.json()
            const annotazioni = {
                    "colleghi": 
                        [{"geometry": {"type": "Point", "coordinates": [7.4312653694, 45.5514552182]}, "type": "Feature", "properties": {"note": "", "priority": 1, "codice": "", "uuid": "12oi34uasad8dnwe", "color": "false", "segnalatore": "Grosa M.", "icon": "close", "id": 166620, "public": true}}, {"geometry": {"type": "Point", "coordinates": [7.3131, 45.5045501]}, "type": "Feature", "properties": {"note": "", "priority": 3, "codice": "323223", "uuid": "jnuinwqw08jew", "color": "#990000", "segnalatore": "Bassano B.", "icon": "eye", "id": 166621, "public": true}}, {"geometry": {"type": "Point", "coordinates": [7.135875, 45.4736919]}, "type": "Feature", "properties": {"note": "", "priority": 1, "codice": "", "uuid": "osd09sdcksdasd3op", "color": "false", "segnalatore": "Borney S.", "icon": "alert", "id": 166622, "public": true}}],
                    "personali": 
                        [{"geometry": {"type": "Point", "coordinates": [7.4412653694, 45.5614552182]}, "type": "Feature", "properties": {"note": "", "priority": 1, "codice": "", "uuid": "12oi34unr3489pd8dnwe", "color": "false", "segnalatore": "Grosa M.", "icon": "close", "id": 166620, "public": true}}, {"geometry": {"type": "Point", "coordinates": [7.3231, 45.5145501]}, "type": "Feature", "properties": {"note": "", "priority": 3, "codice": "323223", "uuid": "jnudasdsajew", "color": "#990000", "segnalatore": "Bassano B.", "icon": "eye", "id": 166621, "public": true}}, {"geometry": {"type": "Point", "coordinates": [7.145875, 45.4836919]}, "type": "Feature", "properties": {"note": "", "priority": 1, "codice": "", "uuid": "osd0dsadadasd3op", "color": "false", "segnalatore": "Borney S.", "icon": "alert", "id": 166622, "public": true}}],
                    }
            console.log(annotazioni)

            localStorage.setItem("annotazioni_colleghi",  JSON.stringify(annotazioni.colleghi) )
            localStorage.setItem("annotazioni_personali",  JSON.stringify(annotazioni.personali) )

            // dataStore.userData.annotazioni_personali.features = annotazioni.personali
            // dataStore.userData.annotazioni_colleghi.features = annotazioni.colleghi
            return true
        },



    }


    const local = {


        // getRoot: async () => {  // secure data test get
        //     const options = copyObject(default_local_options())

        //     let response = await fetch(`${localWebServerURL}/`, options).catch(error => {
        //         console.error('There was a problem with the get root operation:', error)
        //     });

        //     console.log('get root response', response?.status)

        //     if (response) {
        //         const htmlRaw = await response.text()
        //         const el = document.createElement( 'html' );
        //         el.innerHTML = htmlRaw;
        //         const files = el.querySelectorAll( 'a[data-directory=false]' ); // Live NodeList of your anchor elements
        //         console.log(files)
        //         return {
        //             response: response,
        //             data: htmlRaw,
        //         }
        //     }
        //     else {
        //         return {
        //             response: response,
        //             data: null,
        //         }
        //     }

        // },


        // getMBTiles: async () => {  // secure data test get
        //     const options = copyObject(default_local_options())

        //     let response = await fetch(`${localWebServerURL}/mbtiles/`, options).catch(error => {
        //         console.error('There was a problem with the get mbtiles operation:', error)
        //     });

        //     console.log('get mbtiles response', response?.status)

        //     if (response) {
        //         const htmlRaw = await response.text()
        //         const el = document.createElement( 'html' );
        //         el.innerHTML = htmlRaw;
                
        //         const files = el.querySelectorAll( 'a[data-directory=false]' ); // Live NodeList of your anchor elements
        //         console.log(files)
                
                
        //         return {
        //             response: response,
        //             data: htmlRaw,
        //         }
        //     }
        //     else {
        //         return {
        //             response: response,
        //             data: null,
        //         }
        //     }

        // },

        // getTiles: async () => {  // secure data test get
        //     const options = copyObject(default_local_options())

        //     let response = await fetch(`${localWebServerURL}/tiles/`, options).catch(error => {
        //         console.error('There was a problem with the get tiles operation:', error)
        //     });

        //     console.log('get tiles response', response?.status)

        //     if (response) {
        //         const htmlRaw = await response.text()
        //         const el = document.createElement( 'html' );
        //         el.innerHTML = htmlRaw;
                
        //         const files = el.querySelectorAll( 'a[data-directory=false]' ); // Live NodeList of your anchor elements
        //         console.log(files)
                
                
        //         return {
        //             response: response,
        //             data: htmlRaw,
        //         }
        //     }
        //     else {
        //         return {
        //             response: response,
        //             data: null,
        //         }
        //     }

        // },

        // getLures: async () => {  // secure data test get
        //     const options = copyObject(default_local_options())

        //     let response = await fetch(`${localWebServerURL}/lures/`, options).catch(error => {
        //         console.error('There was a problem with the get lures operation:', error)
        //     });

        //     console.log('get lures response', response?.status)

        //     if (response) {
        //         const htmlRaw = await response.text()
        //         const el = document.createElement( 'html' );
        //         el.innerHTML = htmlRaw;
                
        //         const files = el.querySelectorAll( 'a[data-directory=false]' ); // Live NodeList of your anchor elements
        //         console.log(files)
                
                
        //         return {
        //             response: response,
        //             data: htmlRaw,
        //         }
        //     }
        //     else {
        //         return {
        //             response: response,
        //             data: null,
        //         }
        //     }

        // },



        list: async (path) => {  // secure data test get
            // const options = copyObject(default_local_options())
            // // options.mode = "no-cors"

            const options = copyObject(default_local_options())
            options.method = 'GET'


            const url = `${localWebServerURL}/api/file/list?path=${path}&sort=default&sort-reversed=false`

            let response = await fetch(`${url}`, options).catch(error => {
                console.error('There was a problem with the get /api/file/list over local webserver operation:', error)
            });

            console.log('get file list response', response?.status)

            if (response) {
                console.log(response)
                return {
                    response: response,
                    data: await response.json(),
                }
            }
            else {
                return {
                    response: response,
                    data: null,
                }
            }

        },



    }
    return {
        trackerURL,
        localWebServerURL,
        tracker,
        local,
    }
})
